document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 750) {
        const selectors = [
            '.banner__heading',
            '.banner__text',
            '.banner__title',
            '.rich-text__text',
            '.page-custom__hero-text',
            '.rich-text__heading'
        ];
        const elements = selectors.flatMap(selector => Array.from(document.querySelectorAll(selector)));
        elements.forEach((block) => {
            if (block) {
                block.innerHTML = block.innerHTML.replace(/<br\s*\/?>/gi, ' ');
                if (!block.style.maxWidth) {
                    block.style.maxWidth = '90vw';
                }
                if (!block.style.marginRight && !block.style.marginLeft) {
                    block.style.marginRight = 'auto';
                    block.style.marginLeft = 'auto';
                }
            }
        });
    }
});
